"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _select = _interopRequireDefault(require("webmotors-react-pj/webinput/select"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _style = require("webmotors-react-pj/frame/modal/store/select-state/style");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    data,
    callback
  } = _ref;
  const [selectedState, setSelectedState] = (0, _react.useState)(false);
  const handleFilterState = value => {
    setSelectedState(value);
    callback(value);
  };
  return _react.default.createElement(_style.StyleDiv, null, _react.default.createElement(_select.default, {
    name: 'searchDealer',
    width: true,
    onChange: e => handleFilterState(e.target.value),
    value: selectedState
  }, _react.default.createElement("option", {
    value: "",
    selected: true
  }, _lang.default.storeGroup.selectStates), data.map(item => _react.default.createElement("option", {
    value: item.title
  }, item.title))));
};
exports.default = _default;